import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";
import { createPaginationModule, defaultPagination } from "@/store/common/pagination";

const pendingRegPag = createPaginationModule('PENDING_REG');

const state = {
    pendingRegistrations: "",
    pendingUsers: [],
    pagination: defaultPagination(),
    loading: false,
    error: null,
}
const mutations = {
    ...pendingRegPag.mutations,
    setPendingRegistrations(state, payload) {
        state.pendingRegistrations = payload;
    },
    SET_PENDING_USERS(state, users) {
        state.pendingUsers = users;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
}
const actions = {
    async fetchPendingRegistrations({ commit }, locationID) {
        try {
            await api.post(`/managelocationajax`, {
                cmd: "getpendingregistrationscount",
                locationid: locationID
            })
                .then((response) => {
                    commit('setPendingRegistrations', response.data);
                })
                .catch((error) => {
                    console.log("Error in getting Pending Registrations", error);
                });
        } catch (error) {
            console.error('Error in getting Pending Registrations:', error);
        }
    },
    /**
     * ✅ Fetch pending user registrations
     * API: GET /api/manage-user?locationid={id}&cmd=pendingregistrations&page_size=&page_number=
     */
    async getPendingUsers({ commit }, { locationId, pageNumber = 1, pageSize = 10 }) {
        try {
            const response = await api.get("/manage-user", {
                params: {
                    locationid: locationId,
                    cmd: "pendingregistrations",
                    page_size: pageSize,
                    page_number: pageNumber,
                },
            });

            if (!response.data?.success) {
                throw new Error("Failed to fetch pending users");
            }

            const users = response.data?.data?.pending_users || [];
            const pagination = response.data?.pagination;

            commit("SET_PENDING_USERS", users);
            commit(pendingRegPag.SET_PAGINATION, pagination);

            return { users, pagination };
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch pending registrations");
            throw new Error(message);
        }
    },

        /**
     * ✅ Approve user registrations
     * POST /api/manageuserajax
     * body: { cmd: "processregistrations", locationid, useridsarray, process_command: "approve" }
     */
    async approveUsers({ commit }, { locationId, userIds }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post(`/manageuserajax`, {
                cmd: "processregistrations",
                locationid: locationId,
                useridsarray: userIds,
                process_command: "approve",
            });

            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to approve users");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

        /**
     * ✅ Deny user registrations
     * POST /api/manageuserajax
     * body: { cmd: "processregistrations", locationid, useridsarray, process_command: "deny" }
     */
    async denyUsers({ commit }, { locationId, userIds }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post(`/manageuserajax`, {
                cmd: "processregistrations",
                locationid: locationId,
                useridsarray: userIds,
                process_command: "deny",
            });

            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to deny users");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },
}

const getters = {
    stPendingRegistrations: (state) => state.pendingRegistrations,
    pendingUsers: (state) => state.pendingUsers,
    pendingPagination: (state) => state.pagination,
    pendingLoading: (state) => state.loading,
    pendingError: (state) => state.error,
}

export default {
    state,
    mutations,
    actions,
    getters,
};